// extracted by mini-css-extract-plugin
export default {"main":"PolicyPage_main__z0Byj","viewer":"PolicyPage_viewer__-VBNT"};